import { Environment } from './types';

const environment: Environment = {
  honeyBadgerApiKey: '27d27d55',
};

export default environment;
